document.addEventListener('click', async (e) => {
  const btn = e.target.closest('[name="add"]');
  if (!btn) return;

  e.preventDefault();

  const form = btn.closest('form');
  if (!form) return;

  // Let native validation run first
  if (!form.checkValidity()) {
    form.reportValidity();
    return;
  }

  const formData = new FormData(form);

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    });

    if (!res.ok) throw new Error('Add to cart failed');

    window.location.href = '/checkout';

  } catch (err) {
    console.error(err);
  }
});

